import {
  ArrowCircleUpIcon,
  CloudUploadIcon,
  CogIcon,
  FingerPrintIcon,
  LockClosedIcon,
  ServerIcon,
} from '@heroicons/react/outline';
import useTranslation from 'next-translate/useTranslation';

const features = [
  {
    name: 'Streamline Your Workflow',
    description:
      'Let AI handle repetitive creative tasks, so your team can focus on strategy and growth.',
    icon: CloudUploadIcon,
  },
  {
    name: 'Tailored for Businesses',
    description:
      'From marketing copy to reports, our AI creates content customized to your industry and brand voice.',
    icon: LockClosedIcon,
  },
  {
    name: 'Speed Meets Quality',
    description:
      'Generate professional-grade content in seconds without compromising on quality.',
    icon: ArrowCircleUpIcon,
  },
  {
    name: 'Collaborate Smarter',
    description:
      'Empower your team with AI tools designed to simplify brainstorming, writing, and editing.',
    icon: FingerPrintIcon,
  },
  {
    name: 'Scalable Solutions',
    description:
      'Whether you are a startup or an enterprise, our AI adapts to your evolving business needs.',
    icon: CogIcon,
  },
  {
    name: 'Cost-Effective Creativity',
    description:
      'Achieve agency-level content without the heavy price tag or dedicated team.',
    icon: ServerIcon,
  },
];

export default function WithLargeScreenshotFeatures() {
  const { t } = useTranslation('b2b');

  return (
    <div className='relative bg-white py-24 dark:bg-slate-900 sm:py-32'>
      <div className='mx-auto max-w-md px-6 text-center sm:max-w-3xl lg:max-w-7xl lg:px-8'>
        <p className='mt-2 text-3xl font-bold tracking-tight text-gray-900 dark:text-slate-200 sm:text-4xl'>
          {t('No creative team? No problem')}
        </p>
        <p className='mx-auto mt-5 max-w-prose text-xl text-gray-500 dark:text-slate-400'>
          {t('Transform Ideas Into Impact: Here is Your Seamless B2B Content Creation')}
        </p>
      </div>
      <div className='relative overflow-hidden pt-16'>
        <div className='mx-auto max-w-7xl px-6 lg:px-8'>
          <img
            src='/images/b2b/team.png'
            alt='App screenshot'
            className='mb-[-12%] rounded-xl shadow-2xl ring-1 ring-gray-900/10'
            width={2432}
            height={1442}
          />
          <div className='relative' aria-hidden='true'>
            <div className='absolute -inset-x-20 bottom-0 bg-gradient-to-t from-white pt-[7%] dark:from-slate-900' />
          </div>
        </div>
      </div>
      <div className='mx-auto mt-16 max-w-7xl px-6 sm:mt-20 md:mt-24 lg:px-8'>
        <dl className='mx-auto grid max-w-2xl grid-cols-1 gap-x-6 gap-y-10 text-base leading-7 text-gray-600 dark:text-slate-400 sm:grid-cols-2 lg:mx-0 lg:max-w-none lg:grid-cols-3 lg:gap-x-8 lg:gap-y-16'>
          {features.map((feature) => (
            <div key={feature.name} className='relative pl-9'>
              <dt className='inline font-semibold text-gray-900 dark:text-slate-200'>
                <feature.icon
                  className='absolute left-1 top-1 h-5 w-5 text-indigo-600'
                  aria-hidden='true'
                />
                {t(feature.name)}
              </dt>{' '}
              <dd className='inline'>{t(feature.description)}</dd>
            </div>
          ))}
        </dl>
      </div>
    </div>
  );
}
